import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

type ScrollBehavior = "instant" | "smooth" | "auto";

interface ScrollToTopProps {
  behavior?: ScrollBehavior;
  delay?: number;
}

const ScrollToTop = ({ behavior = "instant", delay = 0 }: ScrollToTopProps) => {
  const { pathname } = useLocation();
  const prevPathnameRef = useRef(pathname);

  useEffect(() => {
    // Skip if same path (hash changes, etc.)
    if (prevPathnameRef.current === pathname) return;
    prevPathnameRef.current = pathname;

    const scrollToTop = () => {
      // Use instant scroll for better UX during page transitions
      // The page fade animation handles the visual transition
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: behavior,
      });
    };

    if (delay > 0) {
      const timer = setTimeout(scrollToTop, delay);
      return () => clearTimeout(timer);
    } else {
      // Immediate scroll, but use requestAnimationFrame for better timing
      requestAnimationFrame(scrollToTop);
    }
  }, [pathname, behavior, delay]);

  return null;
};

export default ScrollToTop;
